import { render, staticRenderFns } from "./Dominik.vue?vue&type=template&id=6d68ca58&scoped=true&"
var script = {}
import style0 from "./Dominik.vue?vue&type=style&index=0&id=6d68ca58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d68ca58",
  null
  
)

export default component.exports